module.exports = __webpack_public_path__ + "img/clouds_3_night.2d2d536c.svg";